import React from 'react';
import { SignIn } from 'aws-amplify-react';
import SignInPage from './SignInPage';

class CustomSignIn extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];
  }

  showComponent() {
    return (
      <div>
        <SignInPage
          onSignIn={super.signIn.bind(this)}
          handleChange={this.handleInputChange.bind(this)}
        />
      </div>
    );
  }
}

export default CustomSignIn;
